"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardTitleText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../../styles/helperFunctions");

var _BaseTextObject = _interopRequireDefault(require("../BaseTextObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCardTitleText = (0, _styledComponents.default)(_BaseTextObject.default).withConfig({
  displayName: "CardTitleTextstyles__StyledCardTitleText",
  componentId: "udoxft-0"
})(["font-weight:", ";margin-left:", ";@media only screen and (min-width:", "){margin-left:0;}"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return props.theme.smallBreak;
});
exports.StyledCardTitleText = StyledCardTitleText;